import { useAutoAnimate } from "@formkit/auto-animate/react";
import { useMemberAsMemberNew } from "@gymflow/api";
import { usePortalRoutes } from "apps/portal/src/hooks";
import { RouteFeature } from "apps/portal/src/routes";
import useGymflowModels from "apps/portal/src/store";

import useRedirectIfNotAuthenticated from "../useRedirectIfNotAuthenticated";
import { HostedPagesAppsBanner } from "./components/HostedPagesAppsBanner";
import { EditMemberSidebarProvider } from "./components/HostedPagesEditProfile/EditMemberSidebarProvider";
import { HostedPagesProfileMembershipStatuses } from "./components/HostedPagesProfileMembershipStatuses/HostedPagesProfileMembershipStatuses";
import { HostedPagesProfileMenu } from "./components/HostedPagesProfileMenu";
import { HostedPagesProfileUserBlock } from "./components/HostedPagesProfileUserBlock";

export const HostedPagesProfile = () => {
  const { createSiteOrEmbedLink } = usePortalRoutes();
  const [parent] = useAutoAnimate();
  const { api } = useGymflowModels();

  useRedirectIfNotAuthenticated(
    createSiteOrEmbedLink(
      RouteFeature.SiteBuyMembershipType.replace(":membershipType", "all"),
    ),
  );

  const { data: userMember, isLoading: isLoadingUserMember } =
    useMemberAsMemberNew({ api });
  return (
    <EditMemberSidebarProvider>
      <div className="flex h-full max-h-full flex-col overflow-auto bg-gray-50 dark:bg-gray-800">
        <div className="track-height flex flex-col justify-center gap-3  bg-gray-50 p-4 lg:flex-row lg:gap-4 lg:p-6 lg:px-28 dark:bg-gray-800">
          <div
            ref={parent}
            className="flex h-fit flex-col gap-2 lg:max-w-lg lg:flex-1"
          >
            <HostedPagesProfileUserBlock
              userMember={userMember}
              isLoadingUserMember={isLoadingUserMember}
            />
            <HostedPagesProfileMembershipStatuses
              userMember={userMember}
              isLoadingUserMember={isLoadingUserMember}
            />
            <HostedPagesAppsBanner />
          </div>
          <HostedPagesProfileMenu />
        </div>
      </div>
    </EditMemberSidebarProvider>
  );
};
